
/*
 * @Author: 曹捷
 * @Date: 2021-03-15 17:07:52
 * @LastEditors: 曹捷
 * @LastEditTime: 2022-04-15 15:47:21
 * @Description: 基础示例
 */
import { baseUrl } from './../url'
import { util } from 'obit-wui'

export default function (api) {
  function URL () {
    return baseUrl
  }
  return {
    sysGet (url, data) {
      return api.get(`${URL()}${url}`, data)
    },
    sysPost (url, data) {
      return api.post(`${URL()}${url}`, data)
    },
    basePost (url, data) {
      return api.post(`${URL()}${url}`, data)
    },
    sysTablePost (url, data) {
      return api.tablePost(`${URL()}${url}`, data)
    },
    sysGetTreeSelect (data) {
      function setParent (item, parentId = '') {
        item.forEach(element => {
          element.parentId = parentId ? parentId : 0
          if (element.children && element.children.length > 0) {
            setParent(element.children, element.id)
          }
        })
      }
      return new Promise((success, error) => {
        api.post(`${URL()}system/dept/treeselect`, data).then(res => {
          setParent(res)
          success(res)
        }).catch(e => {
          error(e)
        })
      })
    },
    saveSystemUserInfo (data, type) {
      return api.post(`${URL()}system/user/${type}`, data)
    },
    getTreeAllKeys (items, itemKey) {
      let arrKey = []
      let appKey = []
      function getKeys (item) {
        item.forEach(element => {
          if (itemKey.findIndex(el => el == element.id) != -1) appKey.push(element.appId)
          arrKey.push(element.id)
          if (element.children && element.children.length > 0) {
            getKeys(element.children)
          }
        })
      }
      return new Promise((success, error) => {
        getKeys(items)
        success({ arrKey: arrKey, appKey: util.util.ArrayUnique(appKey) })
        error('error')
      })
    },
    saveSystemUserInfo (data, type) {
      return api.post(`${URL()}system/user/${type}`, data)
    },
    saveAppRole (data, type) {
      return api.post(`${URL()}system/role/${type}`, data)
    },
    // 获取系统菜单树
    getSystemMenuTree (data) {
      return api.post(`${URL()}system/menu/treeselect`, data)
    },
    //获取角色详情信息
    getAppRoleDetail (data) {
      return api.post(`${URL()}system/role/detail/${data}`, data)
    },
    getAppRolePermission (data) {
      return api.post(`${URL()}system/menu/roleMenuTreeselect/${data}`, data)
    },
    getAppRoleDataScope (data) {
      return api.post(`${URL()}system/dept/roleDeptTreeselect/${data}`, data)
    },
    saveAppRoleDataScope (data) {
      return api.post(`${URL()}system/role/dataScope`, data)
    },
  }
}